import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { StackModule } from '../stack/stack.module';

import { CardComponent } from './card.component';

@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule, StackModule],
  exports: [CardComponent],
})
export class CardModule {}
